export const DEMO_DASHBOARD = '/demo'
export const DEMO_INVOICES = '/demo/invoices'
export const DEMO_INVOICE_NEW = '/demo/invoices/new'
export const demoInvoicePath = (docEntry) => `/demo/invoices/${docEntry}`

export const DEMO_DATABASE = ''

export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

export const IMEI_FALLBACK_PAGE_SIZE = 100

export const SEARCH_DEBOUNCE_MS = 300
export const SEARCH_MIN_CHARS = 2

export const SALE_TYPE_OPTIONS = [
	{ value: '', label: 'Hammasi' },
	{ value: 'cash', label: 'Naqd' },
	{ value: 'credit', label: 'Nasiya' },
]

export const DOC_STATUS_OPTIONS = [
	{ value: '', label: 'Hammasi' },
	{ value: 'O', label: 'Ochiq' },
	{ value: 'C', label: 'Yopiq' },
]

export const CANCELED_OPTIONS = [
	{ value: 'N', label: 'Bekor qilinmagan' },
	{ value: 'Y', label: 'Bekor qilinganlar' },
	{ value: '', label: 'Hammasi' },
]

export const TYPE_INVOICE_OPTIONS = [
	{ value: 'Naqd', label: 'Naqd' },
	{ value: 'Nasiya', label: 'Nasiya' },
]


export const INSTALLMENT_MONTH_OPTIONS = [
	2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 18, 24,
]

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_VIEW_FORMAT = 'DD.MM.YYYY'

export const PLAN_TYPE_BASIC = 'basic'
export const PLAN_TYPE_VIP = 'vip'

export const PLAN_TYPE_OPTIONS = [
	{ value: PLAN_TYPE_BASIC, label: 'Oddiy' },
	{ value: PLAN_TYPE_VIP, label: 'B2B' },
]
